import { MediaType } from '../media-types';
import { getSimpleExt } from '../utils/ext';
import {
	extToPreferredExt,
	extToPreferredMediaType,
	mediaTypeToExts,
	mediaTypeToOthers,
} from './mapping';

export function preferredTypeFromType(type: string | null | undefined): string | undefined {
	if (type) {
		// return mediaTypeToPreferred.get(mediaType);
		return mediaTypeToOthers.get(type)?.[0];
	}
}

export function preferredExtFromExt(ext: string | null | undefined): string | undefined {
	if (ext) {
		ext = ext.toLowerCase();
		ext = ext[0] === '.' ? ext.slice(1) : ext;
		// return mediaTypeToPreferred.get(mediaType);
		const ext2 = extToPreferredExt.get(ext);
		return ext2 ? '.' + ext2 : ext;
	}
}

export function preferredExtFromType(type: string | null | undefined): string | undefined {
	if (type) {
		const ext = mediaTypeToExts.get(type)?.[0];
		return ext && ext[0] !== '.' ? '.' + ext : ext;
	}
}

export function preferredTypeFromExt(ext: string | null | undefined): string | undefined {
	if (ext) {
		ext = ext.toLowerCase();
		return extToPreferredMediaType.get(ext[0] === '.' ? ext.slice(1) : ext);
	}
}

export function expandWithOtherTypes(types: Iterable<string>): Set<string> {
	const set = new Set<string>();
	for (const mediaType of types) {
		set.add(mediaType);

		const others = mediaTypeToOthers.get(mediaType);
		if (others) {
			for (const other of others) {
				set.add(other);
			}
		}
	}

	return set;
}

export function typeAndExtMatch(type: string | undefined, ext: string | undefined): boolean {
	if (!type || !ext) {
		// Can't really determine
		return false;
	}

	const preferredType = preferredTypeFromType(type);
	if (!preferredType) {
		// Can't really determine
		return false;
	}

	const extType = preferredTypeFromExt(ext);
	if (!extType) {
		// Can't really determine
		return false;
	}

	return preferredType === extType;
}

export function ensureExtOrEquivalent(type: string, filename: string): string {
	const preferredType = preferredTypeFromType(type);
	const preferredExt = preferredExtFromType(type);

	if (!preferredType || !preferredExt) {
		// Not a known type...nothing we can do
		return filename;
	}

	// Try to add an extension to generated filename
	const currentExt = getSimpleExt(filename);
	if (!currentExt) {
		// Add best ext
		return filename + preferredExt;
	}

	// Check if the current ext is okay for the media type
	const preferredTypeOfExt = preferredTypeFromExt(currentExt);
	if (preferredTypeOfExt === preferredType) {
		// Current ext is good, return as is
		return filename;
	}

	console.dir({
		preferredType,
		preferredExt,
		currentExt,
		preferredTypeOfExt,
	});

	// Append best ext
	return filename + preferredExt;
}

export function isOctetStream(type: string | undefined): boolean {
	type = type?.toLowerCase();
	return MediaType.OctetStream === type || MediaType.OctetStream2 === type;
}
